module.exports = "/logo-horizontal-1c559b26c241dca0f1ebf3ca43f556dc.svg";